export default "__VITE_ASSET__7507523a__"